// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y6EI2mkUX4Azgl {
  display: inline-block;
  margin-bottom: var(--ds-space-200, 16px);
  padding: var(--ds-space-0, 0);
  border: none;
  background: transparent;
  text-decoration: underline;
}
.Y6EI2mkUX4Azgl:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .Y6EI2mkUX4Azgl:focus {
  outline-color: -webkit-focus-ring-color;
}
.Y6EI2mkUX4Azgl:focus .mac.firefox {
  outline-color: AccentColor;
}
.Y6EI2mkUX4Azgl:hover {
  background-color: transparent;
}
.Y6EI2mkUX4Azgl:active {
  background-color: transparent;
}
.dSnT8Bs3n9p4KN {
  color: var(--ds-text-subtle, #44546f);
}
.dSnT8Bs3n9p4KN:hover {
  background-color: transparent;
  color: var(--ds-text, #172b4d);
}
.b7SpLqIN99pkn_ {
  z-index: 2;
  color: var(--ds-text-inverse, #ffffff);
}
.b7SpLqIN99pkn_:hover {
  color: var(--ds-text-inverse, #ffffff);
}
.cdiljUCK4DccE_ {
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0);
}
.ZDZF80Bi9DREs_ {
  margin-top: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-200, 16px);
}
.S9d66kbFFu9BVD {
  margin-top: var(--ds-space-100, 8px);
}
.JtXAc42Y2TMWC8 {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin-right: 30px;
  background: none;
  color: var(--ds-text-disabled, #091e424f);
  text-align: left;
  cursor: default;
}
.JtXAc42Y2TMWC8:hover {
  background: none;
  color: var(--ds-text-disabled, #091e424f);
}
.JtXAc42Y2TMWC8:active {
  background: none;
  color: var(--ds-text-disabled, #091e424f);
}
.DlewEZT8XYIbGm {
  margin-top: var(--ds-space-100, 8px);
}
.MlTRIazJxr8All {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
}
.GjNYi_nBbcCqTN {
  margin-top: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var cta = `Y6EI2mkUX4Azgl`;
export var lightModeCta = `dSnT8Bs3n9p4KN`;
export var darkModeCta = `b7SpLqIN99pkn_`;
export var boardMenuPromptFullWrapper = `cdiljUCK4DccE_`;
export var butlerUpsellPopoverPromptFullWrapper = `ZDZF80Bi9DREs_`;
export var createBoardModalWrapper = `S9d66kbFFu9BVD`;
export var disabledCta = `JtXAc42Y2TMWC8`;
export var customFieldUpgradeSection = `DlewEZT8XYIbGm`;
export var customFieldUpgradeParagraph = `MlTRIazJxr8All`;
export var customFieldUpgradePrompt = `GjNYi_nBbcCqTN`;
export default ___CSS_LOADER_EXPORT___;
